var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ReloadItem"},[_c('p',{staticClass:"ReloadItem__Title"},[_vm._v("現在地付近のスポット")]),_c('button',{staticClass:"ReloadItem__Button",attrs:{"type":"button"},on:{"click":_vm.handleClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }